import { Routes } from '@angular/router';

import { confirmUnsavedChangesGuard, setupFeatureFlagsForModule } from '@core/shared/util';

import { ArticleRangesOverviewComponent } from './pages';

const baseTitle = 'Katalogmanagement | Sortiment';

export const ARTICLE_RANGES_ROUTES: Routes = [
  {
    path: '',
    component: ArticleRangesOverviewComponent,
    title: `${baseTitle}e`,
    data: setupFeatureFlagsForModule({ customHeader: true }),
    children: [
      {
        path: 'create',
        loadComponent: async () => (await import('./pages/create-form/create-form.component')).CreateFormComponent,
        title: `${baseTitle} erstellen`,
        canDeactivate: [confirmUnsavedChangesGuard],
      },
      {
        path: ':articleRangeId',
        loadComponent: async () => (await import('./pages/edit-form/edit-form.component')).EditFormComponent,
        title: `${baseTitle} bearbeiten`,
        canDeactivate: [confirmUnsavedChangesGuard],
      },
    ],
  },
];
